import {SHOW_MODAL} from '../consts/action-types';

export const show = () => ({
  type: SHOW_MODAL,
  payload: {},
});
